export default __webpack_public_path__ + "static/media/home.73322e25.jpg";